module.exports = __webpack_public_path__ + "static/media/Source Info.e5160c89.txt";